//This file is automatically rebuilt by the Cesium build process.
export default "bool czm_backFacing()\n\
{\n\
return gl_FrontFacing == false;\n\
}\n\
";
